export default __webpack_public_path__ + "img/cloud-migration.1e9a986e.png";